import { useToasts } from "@/hooks/toasts";
import { useRouter } from "next/router";
import { Button, Image } from "react-bootstrap";
import { useEffect, useState } from "react";
import axios from "@/lib/axios";

const PrivacyPolicy = () =>
{
  const router = useRouter();
  const { addToast } = useToasts();
  const [pdfUrl, setPdfUrl] = useState(null);

  useEffect(() =>
  {
    const fetchCustomerPrivacy = async () =>
    {
      try
      {
        const res = await axios.get("/api/legal-documents/customer_privacy_policy");        
        const url = res?.data?.data?.url  || "/pdf/Customer_Privacy_Policy.pdf";
        setPdfUrl(url);
      } catch
      {
        addToast("danger", "Could not load customer privacy policy");
        setPdfUrl("/pdf/Customer_Privacy_Policy.pdf");
      }
    };
    fetchCustomerPrivacy();
  }, [addToast]); 


  return (
    <div>
      <div className="card shadow p-4">
        <div className="d-flex align-items-center justify-content-between mb-4">
          <div className="d-flex align-items-center gap-2">
            <Image
              src="/images/instant-polls-logo.jpg"
              alt="Instant Polls Logo"
              width={150}
              height={40}
              className="object-contain"
            />
          </div>
          <h4 className="mb-0 text-center">Customer Privacy Policy</h4>
          <Button variant="primary" onClick={() => router.back()}>
            Back
          </Button>
        </div>
        {pdfUrl && (
          <iframe
            src={pdfUrl}
            width="100%"
            height="600"
            className="PhoneInputInput"
            title="Customer Privacy Policy"
          />
        )}
      </div>
    </div>
  );
};

export default PrivacyPolicy;
PrivacyPolicy.layout = "blank";